import { render, staticRenderFns } from "./hb.vue?vue&type=template&id=694563f5&scoped=true&"
import script from "./hb.vue?vue&type=script&lang=js&"
export * from "./hb.vue?vue&type=script&lang=js&"
import style0 from "./hb.vue?vue&type=style&index=0&id=694563f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694563f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694563f5')) {
      api.createRecord('694563f5', component.options)
    } else {
      api.reload('694563f5', component.options)
    }
    module.hot.accept("./hb.vue?vue&type=template&id=694563f5&scoped=true&", function () {
      api.rerender('694563f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/hb.vue"
export default component.exports